/** @jsx jsx */

import React, { useState, forwardRef } from 'react'
import { jsx } from 'theme-ui'
import { TruCaret } from '@uswitch/spark-icons/tru'

const SimpleDropDown = forwardRef((props, ref) => {
  const {
    hasError,
    name,
    value,
    options,
    placeholder,
    isSingleRow,
    handleTrackInteraction = () => {},
    onChange = () => {},
  } = props
  const [hasFocus, setHasFocus] = useState(false)

  const handleOnBlur = (e) => {
    handleTrackInteraction(e)
    setHasFocus(false)
  }

  const variantPath = isSingleRow
    ? 'elements.simple-drop-down.singleRow'
    : 'elements.simple-drop-down'

  const dropdownVariant = hasError
    ? `${variantPath}.select.error`
    : hasFocus
    ? `${variantPath}.select.focus`
    : `${variantPath}.select.base`
  return (
    <div
      sx={{
        position: 'relative',
        variant: 'elements.drop-down.container',
      }}
    >
      <select
        name={name}
        value={value}
        onChange={onChange}
        ref={ref}
        onFocus={() => setHasFocus(true)}
        onBlur={handleOnBlur}
        sx={{
          variant: dropdownVariant,
        }}
      >
        <If condition={placeholder}>
          <option value='' disabled defaultValue>
            {placeholder}
          </option>
        </If>
        {options.map(({ label, value }, index) => (
          <option value={value} key={index}>
            {label}
          </option>
        ))}
      </select>
      <span
        sx={{
          variant: isSingleRow
            ? 'elements.simple-drop-down.singleRow.span'
            : 'elements.simple-drop-down.span',
        }}
      >
        <TruCaret color='black' direction='down' sx={{ transform: 'rotate(0.5turn)' }} />
      </span>
    </div>
  )
})

export default SimpleDropDown
